/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_Category_ClonedInputs */



/**
* | output |
* | --- |
* | "Cloned" |
*
* @param {Voice_Manager_Elevenlabs_Category_ClonedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_category_cloned = /** @type {((inputs?: Voice_Manager_Elevenlabs_Category_ClonedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_Category_ClonedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Clonée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geklont")
	if (locale === "it") return /** @type {LocalizedString} */ ("Clonata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Клонированный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Clonada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("克隆")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クローン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लोन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Clonada")
	return /** @type {LocalizedString} */ ("Cloned")
});